
<app-menu-template3>
  <main *ngIf="dataTabla.paging.totalItems >= 1; else no_data">
    <article class="row ml-5 mr-5 mt-4 mb-3">
      <header class="col-12 text-white">
        <div class="row m-auto">
          <div class="col-12 col-md-3" *ngFor="let item of contadorEstados">
            <div class="row m-auto">
              <div
                class="col row shadow p-4 rounded establecimiento-bg-imagen"
                [ngClass]="item.cssClass"
              >
                <img [src]="item.imagen" />
                <div class="col-8 pl-0">
                  <label class="small">Solicitudes RNT</label>
                  <p class="h5 text-capitalize font-weight-bold">
                    {{ item.descripcion }}
                  </p>
                </div>
                <label class="col pl-0 h2">{{ item.cantidad }}</label>
              </div>
            </div>
          </div>
        </div>
      </header>
      <section class="col-12 rounded p-5 mt-4 shadow bg-white">
        <header>
          <div class="row mb-3">
            <!-- <div class="col-md-2 col-sm-12 m-auto">
              <img [src]="camaraUrl" class="d-flex m-auto img-fluid" alt="" height="120" />
            </div> -->
            <div [innerHTML]="descripcion_encabezado" class="col-11"></div>
            <div class="col-1">
              <app-ayudas [ayuda]="ayudaService.establecimiento"></app-ayudas>
            </div>
          </div>
        </header>
        <div class="d-flex justify-content-between">
          <div>
            <span class="badge no-radicado badge-pill pt-2 pb-2 pl-3 pr-3"
              >Sin radicar</span
            >
          </div>
          <p>
            <button
              *ngIf="authService.getTipoUser() !== '8'"
              class="btn btn-primary establecimiento-btn-inicio mb-3 float-right ml-3"
              (click)="onVerificacion()"
            >
              Crear nuevo RNT
            </button>
            <button
              type="button"
              class="btn btn-outline-primary"
              (click)="isCollapsed = !isCollapsed"
              [attr.aria-expanded]="!isCollapsed"
              aria-controls="filtros"
            >
              Ver filtros
            </button>
          </p>
        </div>

        <div id="filtros" [ngbCollapse]="isCollapsed">
          <div class="card mb-3">
            <div class="card-body">
              <form [formGroup]="filtro" (submit)="enviarForm()">
                <div class="row">
                  <div class="col-2 form-group">
                    <label class="small text-secondary mb-0" for=""
                      >Número RNT</label
                    >
                    <input
                      type="text"
                      class="form-control form-control-sm"
                      formControlName="numeroRNT"
                    />
                  </div>
                  <div class="col-2 form-group">
                    <label class="small text-secondary mb-0" for=""
                      >Nombre establecimiento</label
                    >
                    <input
                      type="text"
                      class="form-control form-control-sm"
                      formControlName="numeroEstablecimiento"
                    />
                  </div>
                  <div class="col-2 form-group">
                    <label class="small text-secondary mb-0" for=""
                      >Cámara de Comercio</label
                    >
                    <select
                      class="form-control form-control-sm"
                      id="camara"
                      formControlName="camara"
                    >
                      <option class="" [ngValue]="null" selected="true">
                        Seleccione
                      </option>
                      <option
                        class=""
                        *ngFor="let option of camarasLista; let i = index"
                        value="{{ option?.codigo_camara }}"
                        [selected]="false"
                      >
                        {{ option?.desc_camara }}
                      </option>
                    </select>
                  </div>
                  <div class="col-2 form-group">
                    <label class="small text-secondary mb-0" for=""
                      >Sub categoría</label
                    >
                    <select
                      class="form-control form-control-sm"
                      id="categoria"
                      formControlName="categoria"
                    >
                      <option class="" [ngValue]="null" selected="true">
                        Seleccione
                      </option>
                      <option
                        class=""
                        *ngFor="let option of subCategoriasLista; let i = index"
                        value="{{ option?.sub_categoria_id }}"
                        [selected]="false"
                      >
                        {{ option?.descripcion }}
                      </option>
                    </select>
                  </div>
                  <div class="col-2 form-group">
                    <label class="small text-secondary mb-0" for=""
                      >Estado RNT</label
                    >
                    <select
                      class="form-control form-control-sm"
                      id="estadoRNT"
                      formControlName="estadoRNT"
                    >
                      <option class="" [ngValue]="null" selected="true">
                        Seleccione
                      </option>
                      <option
                        class=""
                        *ngFor="let option of estadoRNTLista; let i = index"
                        value="{{ option?.estado_rnt_id }}"
                        [selected]="false"
                      >
                        {{ option?.descripcion }}
                      </option>
                    </select>
                  </div>
                  <div class="col-2 form-group">
                    <label class="small text-secondary mb-0" for=""
                      >Tipo solicitud</label
                    >
                    <select
                      class="form-control form-control-sm"
                      id="tipo"
                      formControlName="tipo"
                    >
                      <option class="" [ngValue]="null" selected="true">
                        Seleccione
                      </option>
                      <option
                        class=""
                        *ngFor="let option of tipoSolicitudLista; let i = index"
                        value="{{ option?.tipo_solicitud_id }}"
                        [selected]="false"
                      >
                        {{ option?.descripcion }}
                      </option>
                    </select>
                  </div>
                  <div class="col-2 form-group">
                    <label class="small text-secondary mb-0" for=""
                      >Estado solicitud</label
                    >
                    <select
                      class="form-control form-control-sm"
                      id="estadoSolicitud"
                      formControlName="estadoSolicitud"
                    >
                      <option class="" [ngValue]="null" selected="true">
                        Seleccione
                      </option>
                      <option
                        class=""
                        *ngFor="
                          let option of estadoSolicitudLista;
                          let i = index
                        "
                        value="{{ option?.estado_solicitud_id }}"
                        [selected]="false"
                      >
                        {{ option?.descripcion }}
                      </option>
                    </select>
                  </div>
                  <div class="col-2 form-row">
                    <button
                      type="reset"
                      class="btn btn-outline-primary border-0 m-auto"
                      (click)="limpiar()"
                    >
                      Limpiar
                    </button>
                    <button
                      class="btn btn-primary m-auto solicitud-btn-principal"
                      type="submit"
                    >
                      Filtrar
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>

        <ng-container
          class="row"
          *ngIf="
            dataTabla.items != null && dataTabla.items.length > 0;
            else sindatos_campos
          "
        >
          <app-tablas
            [page]="paginaActual"
            [headers]="headersRnt"
            [sizeData]="dataTabla.paging.totalItems"
            class="table-responsive"
            (paginado)="onPaginado($event)"
          >
            <tr
              *ngFor="let item of dataTabla.items; let i = index"
              class="small"
              [style.borderLeft]="
                item.estado_solicitud_id === solicitudSinRadicar
                  ? '8px solid #f57c00'
                  : '8px solid #ffffff'
              "
            >
              <td>{{ item.codigo_rnt }}</td>
              <td>{{ item.descripcion_tipo_rnt }}</td>
              <td>{{ item.razon_social }}</td>
              <td>{{ item.descripcion_camara }}</td>
              <td>{{ item.direccion_comercial }}</td>
              <td>{{ item.descripcion_tipo_establecimiento }}</td>
              <td>
                {{
                  item.fecha_inscripcion == "0001-01-01T00:00:00"
                    ? ""
                    : (item.fecha_inscripcion | date: "d/MMM/yyyy")
                }}
              </td>
              <td>
                {{
                  item.fecha_ultima_renovacion == "0001-01-01T00:00:00"
                    ? ""
                    : (item.fecha_ultima_renovacion | date: "yyyy")
                }}
              </td>
              <td class="d-flex justify-content-between">
                {{ item.descripcion_estado_rnt
                }}<app-ayudas
                  [ayuda]="
                    ayudaService.estadoRntBandejaPrestador(item)
                  "
                  [class]="'establecimiento-ayuda'"
                ></app-ayudas>
              </td>
              <td lass="d-flex justify-content-between">
                {{ item.descripcion_tipo_solicitud }}:
                {{ item.descripcion_estado_solicitud }}
                <ng-container *ngIf="item.motivo_devolucion">
                  <button
                    type="button"
                    class="btn close"
                    [ngbPopover]="item.motivo_devolucion"
                    popoverTitle="Motivo de devolución"
                    triggers="mouseenter:mouseleave"
                  >
                    <!-- (mouseleave)="" -->
                    <img
                      width="18"
                      src="../../../../../../../assets/icons/info.png"
                    />
                  </button>
                </ng-container>
              </td>
              <td>{{ item.numero_radicacion }}</td>
              <td>
                <ng-template #popContent>
                  <ng-container *ngFor="let accionRnt of accionesRnt">
                    <button
                      class="btn btn-outline-light border-0 text-left w-100"
                      (click)="onAcciones(item, accionRnt)"
                    >
                      {{ accionRnt.accion }}
                    </button>
                  </ng-container>
                  <!-- <button class="btn btn-outline-light border-0 text-left w-100" (click)="onAnotacion(item)">Anotaciones</button> -->
                  <!-- <button *ngIf="item.categoria_id === 14 && item.sub_categoria_id === 14" class="btn btn-outline-light border-0 text-left w-100"
                  (click)="onAcciones(item, accionVehiculo)">Gestionar Vehículos</button> -->
                </ng-template>
                <button
                  type="button"
                  class="btn btn-outline-secondary text-center"
                  placement="bottom"
                  [ngbPopover]="popContent"
                  (shown)="onLoadAcciones(item)"
                  (hidden)="onDismissAcciones()"
                  popoverClass="bg-dark"
                >
                  ..
                </button>
              </td>
            </tr>
          </app-tablas>
        </ng-container>

        <ng-template #sindatos_campos>
          <p class="small">
            No se encontraron datos relacionados a la búsqueda
          </p>
        </ng-template>
        <!-- <aside>
          <p>
            <strong>¿Qué signican los estados de RNT?</strong>
          </p>
        </aside> -->
      </section>
    </article>
  </main>
  <ng-template #no_data>
    <ng-container *ngIf="cargaPantalla; else empty">
      <ngx-spinner
        bdColor="rgba(51, 51, 51, 0.8)"
        size="large"
        color="#fff"
        type="ball-pulse"
      ></ngx-spinner>
    </ng-container>
    <ng-template #empty>
      <main class="container mb-3 bg-white mt-3 p-5 shadow-lg">
        <section class="row text-center">
          <header class="col-12">
            <figure class="figure w-100">
              <img
                class="img-fluid mb-4"
                src="../../../../../../../assets/images/sin_establecimiento.png"
              />
              <figcaption>
                <label class="h3">Aún no tienes solicitudes RNT</label>
              </figcaption>
            </figure>
          </header>
          <footer class="col-md-6 m-auto">
            <p class="text-muted">
              Aquí se mostrarán todas tus solicitudes RNT por cada
              establecimiento registrado
            </p>
            <button
              *ngIf="authService.getTipoUser() !== '8'"
              class="btn text-white establecimiento-btn-inicio"
              (click)="onVerificacion()"
            >
              Empezar
            </button>
          </footer>
        </section>
      </main>
    </ng-template>
  </ng-template>
</app-menu-template3>
